module.exports = __webpack_public_path__ + "static/media/12.f442be77.png";